import { SeoIllustration } from '@assets/illustrations';
import AuthCtx from '@auth/AuthCtx';
import { useSettingsContext } from '@components/settings';
import { Button, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Container } from '@mui/system';
import { AppWelcome, AppWidgetSummary } from '@sections/general/app';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import Head from 'next/head';

GeneralAppPage.getLayout = (page: React.ReactElement) => <DashboardLayout>{page}</DashboardLayout>;

// ----------------------------------------------------------------------

export default function GeneralAppPage() {
  const theme = useTheme();

  const { themeStretch } = useSettingsContext();
  const { user } = AuthCtx.useCtx();

  return (
    <>
      <Head>
        <title>Cổng thông tin quản lý</title>
      </Head>

      <Container maxWidth={themeStretch ? false : 'xl'}>
        <Grid container spacing={1} marginBottom="2rem">
          <Grid item xs={12} md={12}>
            <AppWelcome
              sx={{ p: 2 }}
              title={`Chào mừng bạn! \n ${user?.full_name || user?.username}`}
              description="Chào mừng bạn đến với hệ thống quản lý. Hãy bắt đầu khám phá các tính năng tuyệt vời mà chúng tôi cung cấp để nâng cao hiệu quả công việc của bạn."
              img={
                <SeoIllustration
                  sx={{
                    p: 3,
                    width: 360,
                    margin: { xs: 'auto', md: 'inherit' },
                  }}
                />
              }
              action={<Button variant="contained">bắt đầu ngay</Button>}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <AppWidgetSummary
              title="Tổng số người dùng đang hoạt động"
              percent={2.6}
              total={18765}
              chart={{
                colors: [theme.palette.primary.main],
                series: [5, 18, 12, 51, 68, 11, 39, 37, 27, 20],
              }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <AppWidgetSummary
              title="Tổng số cài đặt"
              percent={0.2}
              total={4876}
              chart={{
                colors: [theme.palette.info.main],
                series: [20, 41, 63, 33, 28, 35, 50, 46, 11, 26],
              }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <AppWidgetSummary
              title="Tổng số lượt tải xuống"
              percent={-0.1}
              total={678}
              chart={{
                colors: [theme.palette.warning.main],
                series: [8, 9, 31, 8, 16, 37, 8, 33, 46, 31],
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
